import { Component, Input, AfterViewInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-trend-report',
  templateUrl: './trend-report.component.html',
  styleUrls: ['./trend-report.component.scss']
})
export class TrendReportComponent implements AfterViewInit, OnChanges {

  @Input() trendReport: any[] = [];
  @Input() userData: any[] = [];
  @Input() chartId: string = 'trend_report';
  @Input() title: string = 'Bug Trend Report';
  @Input() valueKey: string = 'bugs_created';
  @Input() valueLabel: string = 'Bugs Created';
  @Output() tendOwnerChange = new EventEmitter();

  ngOnChanges(changes: SimpleChanges) {
  if (changes['trendReport'] && !changes['trendReport'].firstChange) {
    this.renderTrendChart();   // 🔥 Re-render chart when trend data changes
  }
}
  ngAfterViewInit() {
    if (this.trendReport?.length > 0) {
      this.renderTrendChart();
    }
  }
  filterByOwner(event:any) {
    console.log(event.target.value)
   this.tendOwnerChange.emit(event.target.value)
  }
  renderTrendChart() {

     const labels = this.trendReport.map(r => r.date);
  const values = this.trendReport.map(r => r[this.valueKey] || 0);

  const canvas = document.getElementById("canvas_" + this.chartId) as HTMLCanvasElement;
  if (!canvas) return;

  const ctx = canvas.getContext('2d');

  // 🔥 Destroy previous chart safely
  const existing = Chart.getChart(canvas);
  if (existing) {
    existing.destroy();
  }



    // Create Line Chart
    new Chart(ctx!, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            label: this.valueLabel,
            data: values,
            borderColor: '#007bff',
            backgroundColor: 'rgba(0, 123, 255, 0.2)',
            tension: 0.4,
            pointRadius: 3,
            pointBackgroundColor: '#007bff',
            fill: true,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 300
        },
        scales: {
          x: {
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
            grid: { display: false }
          },
          y: {
            beginAtZero: true,
            grid: { display: false }
          }
        },
        plugins: {
          legend: { display: true },
          tooltip: { enabled: true }
        }
      }
    });
  }
}
